import React, {useEffect, useState} from 'react';
import {Tab, TabSection} from '@components/screens/tabSection/TabSection';
import {translate} from '@utils/languageTools';
import {ContactsInvoiceList} from '@components/screens/contacts/tabWindows/ContactsInvoiceList';
import {RecordScreen} from '@src/types/Record/recordScreen';
import Requests from '../../../../api/Requests';
import {logError} from '@utils/debug';
import {CustomRecordData} from '@components/screens/minimizedRecordList/MinimizedRecordList';

const invoiceSummaryKeys = ['NotOverDue', 'Open', 'OverDue'];

type ContactsTabSectionProps = {
  window: RecordScreen<any, any>;
  show: boolean;
};

export const ContactsTabSection: React.FC<ContactsTabSectionProps> = ({window, show}) => {
  const [invoiceData, setInvoiceData] = useState<CustomRecordData>(null);
  const [salesOrderData, setSalesOrderData] = useState<CustomRecordData>();

  useEffect(() => {
    initializeRecords();
  }, []);

  function initializeRecords() {
    Requests.doAction('getcustomerstatusrecords', {id: window.id, replyArray: true})
      .then((response) => processResponse(response))
      .catch((error) => handleFailedRecordRequest(error));
  }

  function handleFailedRecordRequest(error) {
    logError(error);
    processResponse({records: []});
  }

  function processResponse(response) {
    if (response.records.length === 0) {
      handleEmptyResponse();
      return;
    }
    populateInvoiceData(response.records);
  }

  function handleEmptyResponse() {
    setInvoiceData({records: [], summaryData: {totals: [], keys: [], suffixKey: ''}});
  }

  function populateInvoiceData(records: any[]) {
    const invoiceTotals = records.find((record) => record.Type === 'invoicetotals');
    const invoiceRecords = records.filter((record) => record.Type === 'invoice');
    setInvoiceData({
      records: invoiceRecords,
      summaryData: {totals: invoiceTotals, keys: invoiceSummaryKeys, suffixKey: 'Currency'},
    });
  }

  function populateSalesOrderData() {}

  const statusTabs: Tab[] = [
    {
      name: translate('Invoices'),
      component: <ContactsInvoiceList window={window} recordData={invoiceData} />,
    },
    {
      name: translate('SalesOrders'),
      component: <> Sales Orders </>,
    },
  ];

  if (!invoiceData) return <></>;
  if (!show) return <></>;
  return <TabSection tabs={statusTabs} />;
};
